<template>
  <elements-layout
          :extra-filters="extraFilters"
          :table-columns='tableColumns'
          :fetch-data-url='fetchDataUrl'

          :tableRepresentation="true"

          :store-module-name="STORE_MODULE_NAME"
          :store-module-config="STORE_MODULE_CONFIG"

          :addDataSidebarAvailable="$can('create', 'fencing')"

  >

    <template #addDataForm>
      <fencing-add-update></fencing-add-update>
    </template>

    <template #tableCellCustomRepresentations="cell">

        <template v-if="cell.field.key === 'fencing'">
            <template v-if="get(cell.item, 'id')">
                <fencing-cell :data="cell.item"></fencing-cell>
            </template>
            <template v-else>
                {{cell.item}}
            </template>
        </template>
        <template v-else-if="cell.field.key === 'platform'">
            <template v-if="get(cell.value, 'id')">
                <platform-cell :data="cell.value"></platform-cell>
            </template>

        </template>
        <template v-else-if="cell.field.key === 'user'">
            <template v-if="get(cell.value, 'id')">
                <user-cell :user="cell.value"></user-cell>
            </template>

        </template>
    </template>

  </elements-layout>
</template>

<script>

  import ElementsLayout from '@core/components/app-elements/AppElementsLayout.vue'

  import {STORE_MODULE_NAME, STORE_MODULE_CONFIG} from '../fencingStoreModule'
  import useFencing from '../useFencing'

  import FencingAddUpdate from '../components/FencingAddUpdate'

  import get from 'lodash.get'

  import UserCell from "@/views/apps/user/components/UserCell";

  import FencingCell from "@/views/apps/railway_structure/fencing/components/FencingCell";
  import PlatformCell from "@/views/apps/railway_structure/platform/components/PlatformCell";

  export default {
    props: {
      // Фильтр приходит из карточки родителя: список внутри вкладки обязан
      // показывать только подчинённые записи, а не всё подряд
      extraFilters: {
        type: Object,
        default: () => ({}),
        required: false,
      },
    },
    components: {
        PlatformCell,
        UserCell,
      FencingCell,
      ElementsLayout,
      FencingAddUpdate,
    },
    setup() {

      const {

        fetchDataUrl,
        deleteDataUrl,
        tableColumns,

      } = useFencing();

      return {
        fetchDataUrl,
        deleteDataUrl,
        tableColumns,

        STORE_MODULE_NAME,
        STORE_MODULE_CONFIG,

        get,
      }
    },
  }
</script>
